<script>
import { mapGetters } from 'vuex'
import PaymentMethod from '../../components/PaymentMethod.vue'
import CashWallet from '../../components/CashWallet.vue'

export default {
    name: 'AccountPayment',
    components: { PaymentMethod, CashWallet },
    computed: {
        ...mapGetters(['userResource']),
        showCashWallet() {
            return !!(this.userResource && this.userResource.get('cash_wallet_enabled'))
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Paiement</h4>
            <p class="text-muted mb-0">Gérez votre mode de paiement enregistré.</p>
        </div>
        <b-card>
            <b-row>
                <b-col md="6">
                    <h4>Carte de crédit</h4>
                    <payment-method cols-lg="12" :user-resource="userResource" />
                    <hr class="d-block d-md-none" />
                </b-col>
                <b-col>
                    <h4>Portefeuille des tournois en argent</h4>
                    <cash-wallet />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
